// My Style タグ候補（アプリ側 lib/9.type/style_tag.dart と同じID/ラベル対応）
export const STYLE_TAG_LABELS: Record<string, string> = {
  natural: 'ナチュラル',
  korean: '韓国ヘア',
  mode: 'モード',
  girly: 'ガーリー',
  mens: 'メンズスタイル',
  bob: 'ボブ',
  high_tone: 'ハイトーン',
  warm_color: '暖色カラー',
  clear_color: '透明感カラー',
  hair_arrange: 'ヘアアレンジ',
};

export const styleTagLabel = (id: string): string => STYLE_TAG_LABELS[id] || id;

// Growth Log カテゴリ（アプリ側 lib/9.type/growth_log.dart の GrowthLogCategory.label と同じ対応）
export const GROWTH_LOG_CATEGORY_LABELS: Record<string, string> = {
  practice: '練習',
  model: 'モデル施術',
  certification: '検定',
  contest: 'コンテスト',
  school: '学校行事',
  seminar: 'セミナー',
  job_hunting: '就職活動',
  other: 'その他',
};

export const growthLogCategoryLabel = (category: string): string =>
  GROWTH_LOG_CATEGORY_LABELS[category] || GROWTH_LOG_CATEGORY_LABELS.other;

// About Me セクションのうち、idealBeautician以外の「もっと見る」で展開する6項目
export const ABOUT_ME_EXTRA_FIELDS: { key: AboutMeExtraKey; label: string }[] = [
  { key: 'reasonForCareer', label: 'なぜこの仕事を目指したか' },
  { key: 'customerServiceValue', label: '接客で大切にしたいこと' },
  { key: 'favoriteStyle', label: '好きなスタイル' },
  { key: 'currentEffort', label: '今頑張っていること' },
  { key: 'futureGoal', label: '将来の目標' },
  { key: 'salonPreference', label: '就職先への希望' },
];

export type AboutMeExtraKey =
  | 'reasonForCareer'
  | 'customerServiceValue'
  | 'favoriteStyle'
  | 'currentEffort'
  | 'futureGoal'
  | 'salonPreference';
